// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__inter_d47993', system-ui"},"className":"__className_d47993"};